import React from "react";
import { observer } from "mobx-react-lite";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const ResultsBrowser = ({ projectId }) => {
  const results = [
    { id: "001", smiles: "C1=CC=CC=C1", dockingScore: -9.2, admet: 0.85, mw: 78.11, logp: 2.13 },
    { id: "002", smiles: "C1=CC=C(C=C1)C=O", dockingScore: -8.7, admet: 0.72, mw: 106.12, logp: 1.78 },
    { id: "003", smiles: "C1=CC=CC=C1Cl", dockingScore: -8.1, admet: 0.91, mw: 112.56, logp: 2.84 },
    { id: "004", smiles: "C1=CC(=CC=C1)O", dockingScore: -7.5, admet: 0.45, mw: 94.11, logp: 1.55 },
  ];

  return (
    <div className="fadein animation-duration-500" style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <div className="screening-header">
        <span className="screening-header-icon">📊</span>
        <span className="screening-header-title">Results</span>
      </div>

      <div className="screening-body">
        {/* Filters */}
        <div className="screening-results-filters">
          <Dropdown value={null} options={[{ label: "All Workflows", value: null }]} placeholder="All Workflows"
            style={{ width: 160 }} />
          <Dropdown value={null} options={[{ label: "All Tools", value: null }]} placeholder="All Tools"
            style={{ width: 140 }} />
          <span className="p-input-icon-left" style={{ flex: 1, maxWidth: 280 }}>
            <i className="pi pi-search" />
            <InputText placeholder="Search compounds..." style={{ width: "100%", paddingLeft: 32 }} />
          </span>
        </div>

        {/* Table */}
        {results.length === 0 ? (
          <div className="screening-empty">
            <div className="screening-empty-icon">📊</div>
            <div className="screening-empty-text">No results yet</div>
            <div className="screening-empty-sub">Run a workflow to see results here</div>
          </div>
        ) : (
          <div className="screening-results-table">
            <DataTable value={results} selectionMode="multiple" paginator rows={10}
              className="screening-table"
              emptyMessage="No data">
              <Column selectionMode="multiple" headerStyle={{ width: 40 }} />
              <Column field="id" header="ID" sortable style={{ width: 80 }} />
              <Column field="smiles" header="SMILES" style={{ minWidth: 180 }}
                body={(row) => (
                  <span style={{ fontFamily: "'SF Mono', 'Fira Code', 'Consolas', monospace", fontSize: "0.78rem", color: "#475569" }}>
                    {row.smiles} 🧪
                  </span>
                )} />
              <Column field="dockingScore" header="Docking" sortable style={{ width: 100 }}
                body={(row) => (
                  <span style={{ color: row.dockingScore < -8 ? "#16a34a" : "#64748b", fontWeight: row.dockingScore < -8 ? 600 : 400 }}>
                    {row.dockingScore}
                  </span>
                )} />
              <Column field="admet" header="ADMET" sortable style={{ width: 100 }}
                body={(row) => (
                  <span style={{ color: row.admet > 0.7 ? "#16a34a" : "#64748b" }}>
                    {row.admet}
                  </span>
                )} />
              <Column field="mw" header="MW" sortable style={{ width: 80 }} />
              <Column field="logp" header="LogP" sortable style={{ width: 80 }} />
            </DataTable>
            <div className="screening-results-bar">
              <span>0 selected</span>
              <div style={{ flex: 1 }} />
              <Button label="Export CSV" icon="pi pi-download" className="p-button-sm p-button-outlined"
                style={{ borderRadius: 4, fontSize: "0.8rem" }} />
              <Button label="Compare" icon="pi pi-chart-bar" className="p-button-sm"
                style={{ background: "#4f46e5", border: "none", borderRadius: 4, fontSize: "0.8rem" }} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(ResultsBrowser);
